<div class="overflow-area">
  <div class="overflow-area__title">
    <h2 class="overflow-area__title__text">
      {{ 'common.overflowAreaLoadModal.title' | translate }}
    </h2>
  </div>

  <div class="overflow-area__buttons">
    <button
      class="overflow-area__buttons__cancel overflow-area__buttons__button"
      (click)="onCancel()"
    >
      {{ 'common.overflowAreaLoadModal.cancel' | translate }}
    </button>
    <button
      class="overflow-area__buttons__complete overflow-area__buttons__button"
      (click)="onComplete()"
    >
      {{ 'common.overflowAreaLoadModal.complete' | translate }}
    </button>
  </div>
</div>
